export const notifications = {
  warning: {
    header: "Hier scheint ein Fehler aufgetreten zu sein.",
    body: "Bitte überprüfen Sie ihre Internetverbindung oder versuchen Sie es zu einem späteren Zeitpunkt erneut."
  },
  repairingFile: {
    header: "Reparatur notwendig.",
    body: "Ihr Bauteil ist noch nicht für den 3D-Druck optimiert und wird für Sie automatisch repariert. Bitte haben Sie einen Moment Geduld."
  },
  technicalDifficulties: {
    header: "Technische Schwierigkeiten",
    body: "Lieber Kunde,\n aufgrund eines Software Updates kann es im Safari-Browser derzeit zu technischen Schwierigkeiten bei dem Upload von 3D-Dateien kommen.\n " +
          "Wir arbeiten mit Hochdruck an einer Lösung und bitten um Ihr Verständnis."
  },
  holiday_leave: {
    header: "Wichtige Information",
    body: "Bestellungen, die nach dem 16.12.22 eingehen, werden erst ab der 2. Kalenderwoche 2023 geliefert."
  }
};
